module.exports = __webpack_public_path__ + "static/media/bg-application3.41359c60.jpg";